import "semantic-ui-css/semantic.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrivateRoute from "./components/users/auth/PrivateRoute";
import AuthRoute from "./components/layout/AuthLayout";
import DashboardLayout from "./components/layout/DashboardLayout";
import SchoolData from "./components/users/Schools/SchoolData";
import HomePage from "./components/common/HomePage";
import EmployeeInvitation from "./components/users/Employees/EmployeeInvitation";

function App() {
  return (
    <Router>
      <Switch>
        <PrivateRoute exact path="/user/:id" component={SchoolData} />
        <PrivateRoute
          path="/dashboard/s/:schoolId"
          component={DashboardLayout}
        />
        <PrivateRoute
          path="/employees/invitation/:empId/:schoolId"
          component={EmployeeInvitation}
        />
        <PrivateRoute
          exact
          path="/"
          component={(props) => <HomePage {...props} />}
        />
        <Route path="/auth" component={AuthRoute} />
      </Switch>
    </Router>
  );
}

export default App;
